import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICompanyAlertSettings } from '../../../message-models/company-alert-settings.interface';
import { CompanyAlertSettings } from '../../../message-models/company-alert-settings.class';
import { ICompanyAlertEmailSettings } from '../../../message-models/company-alert-email-settings.interface';
import { CompanyAlertEmailSettings } from '../../../message-models/company-alert-email-settings.class';

@Component({
  selector: 'app-alert-email-editor',
  templateUrl: './alert-email-editor.component.html',
  styleUrls: ['./alert-email-editor.component.scss']
})
export class AlertEmailEditorComponent implements OnInit {
  @Input() editingType: boolean = false;
  @Input() saveAttempted: boolean = false;
  @Input() emailAddresses: Array<ICompanyAlertEmailSettings> = new Array<ICompanyAlertEmailSettings>();
  @Output() removeEmail: EventEmitter<CompanyAlertEmailSettings> = new EventEmitter<CompanyAlertEmailSettings>();
  @Output() addRecipientEmail: EventEmitter<void> = new EventEmitter<void>();
  public elements: Array<unknown> = [];
  constructor() {
  }

  ngOnInit(): void {
  }

  removeEmailClick(companySettings: CompanyAlertEmailSettings) {
    this.removeEmail.emit(companySettings);
  }
}
